import { render, staticRenderFns } from "./UserRelations.vue?vue&type=template&id=06af23f6"
import script from "./UserRelations.vue?vue&type=script&lang=js"
export * from "./UserRelations.vue?vue&type=script&lang=js"
import style0 from "./UserRelations.vue?vue&type=style&index=0&id=06af23f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports